"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackstageThumbnails = void 0;
var player_base_1 = require("@24i/player-base");
var BackstageThumbnails = (function () {
    function BackstageThumbnails() {
        this.imageUrl = null;
        this.tileWidth = undefined;
        this.tileHeight = undefined;
        this.columns = 1;
        this.timeCodes = [];
        this.interval = Infinity;
    }
    BackstageThumbnails.prototype.isReady = function () {
        return Boolean(this.imageUrl);
    };
    BackstageThumbnails.prototype.load = function (source) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, image, frame, orientation, gridCols, interval;
            return __generator(this, function (_c) {
                _b = (_a = source === null || source === void 0 ? void 0 : source.thumbnails) !== null && _a !== void 0 ? _a : {}, image = _b.image, frame = _b.frame, orientation = _b.orientation, gridCols = _b.gridCols, interval = _b.interval;
                this.imageUrl = image || null;
                this.tileWidth = (frame === null || frame === void 0 ? void 0 : frame.width) || undefined;
                this.tileHeight = (frame === null || frame === void 0 ? void 0 : frame.height) || undefined;
                if (orientation === player_base_1.SourceThumbnailOrientation.HORIZONTAL) {
                    this.columns = Infinity;
                }
                else if (orientation === player_base_1.SourceThumbnailOrientation.VERTICAL) {
                    this.columns = 1;
                }
                else {
                    this.columns = gridCols || 1;
                }
                if (typeof interval === 'number') {
                    this.interval = interval;
                    this.timeCodes = [];
                }
                else if (interval instanceof Array) {
                    this.interval = Infinity;
                    this.timeCodes = __spreadArray([], interval).sort(function (a, b) {
                        return a - b;
                    });
                }
                else {
                    this.interval = Infinity;
                    this.timeCodes = [];
                }
                return [2, this.isReady()];
            });
        });
    };
    BackstageThumbnails.prototype.getThumbnails = function (times) {
        var _this = this;
        return Promise.resolve(times.map(function (time) { return _this.getThumbnail(time); }));
    };
    BackstageThumbnails.prototype.getThumbnail = function (time) {
        var _a = this, interval = _a.interval, timeCodes = _a.timeCodes;
        if (interval > 0.0 && Number.isFinite(interval)) {
            var tileIndex = Math.floor(time / interval);
            var start = tileIndex * interval;
            var end = start + interval;
            return this.buildThumbnail(start, end, tileIndex);
        }
        var timeCodeIndex = this.findTimeCodeIndex(time);
        if (timeCodeIndex >= 0) {
            var start = timeCodes[timeCodeIndex];
            var end = timeCodes[timeCodeIndex + 1];
            return this.buildThumbnail(start, end, timeCodeIndex);
        }
        return null;
    };
    BackstageThumbnails.prototype.buildThumbnail = function (start, end, tileIndex) {
        var _a = this, imageUrl = _a.imageUrl, tileWidth = _a.tileWidth, tileHeight = _a.tileHeight, columns = _a.columns;
        return {
            url: imageUrl,
            start: Number.isFinite(start) ? start : undefined,
            end: Number.isFinite(end) ? end : undefined,
            width: tileWidth || undefined,
            height: tileHeight || undefined,
            x: this.tileWidth
                ? (tileIndex % columns) * this.tileWidth
                : undefined,
            y: this.tileHeight
                ? Math.floor(tileIndex / columns) * this.tileHeight
                : undefined,
        };
    };
    BackstageThumbnails.prototype.findTimeCodeIndex = function (time) {
        var timeCodes = this.timeCodes;
        var minIndex = 0;
        var maxIndex = timeCodes.length - 1;
        while (minIndex < maxIndex) {
            var middleIndex = Math.ceil((minIndex + maxIndex) / 2);
            var middleItem = timeCodes[middleIndex];
            if (middleItem < time) {
                minIndex = middleIndex;
            }
            else if (middleItem > time) {
                maxIndex = middleIndex - 1;
            }
            else {
                return middleIndex;
            }
        }
        if (minIndex === maxIndex) {
            return minIndex;
        }
        return -1;
    };
    return BackstageThumbnails;
}());
exports.BackstageThumbnails = BackstageThumbnails;
//# sourceMappingURL=BackstageThumbnails.js.map